export default {
  cancel: "Cancelar",
  date: "Fecha de creación",
  description: "Descripción",
  dueDate: "Fecha de vencimiento",
  location: "Ubicación",
  multipleBarsChart: "Gasto actual del proyecto",
  name: "Nombre",
  orderId: "Orden Id",
  partialCost: "Costo Unitario",
  projectProfile: "Perfil del proyecto",
  quanty: "Cantidad",
  save: "Guardar",
  subtotal: "Total Parcial",
  subtype: "Subtipo",
  totalCost: "Coste total",
  type: "Tipo",
  whoReceive: "¿Quién recibe?",
  whoSent: "¿Quién envió?",
  newItem: "Nuevo artículo",
  editItem: "Editar artículo",
  structures: "Estructuras",
  personal: "Personal",
  surfaces: "Superficies",
  pipes: "Tuberias",
  disassembly: "Desmontaje",
  manufacturing: "Fabricación",
  assembly: "Montaje",
  replacement: "Reemplazo"
};
